import React from "react";
import { Link } from "react-router-dom";
import { AR_JAMIL } from "./JgShell";
import { WHATSAPP_URL } from "../../utils/contactInfo";
import JgRelatedReading from "./JgRelatedReading";

/**
 * Closing call-to-action band used at the bottom of every page.
 * Optionally renders the three-step process rows.
 * An http(s) `primaryTo` (e.g. Calendly) renders as a plain anchor.
 * On blog posts, service pages and case studies it is preceded by the
 * build-time "Related posts" / "From the blog" block (JgRelatedReading).
 */
const JgCta = ({
  heading,
  lede,
  steps = null,
  primaryLabel = "Start a project",
  primaryTo = "/contact-us",
}) => (
  <>
  <JgRelatedReading />
  <section className="jg-cta" aria-label="Contact">
    <div className="jg-wrap">
      <h2 className="jg-reveal">
        {heading || (
          <>
            Let's build something{" "}
            <em>
              <span className="ar-inline">{AR_JAMIL}</span> — beautiful.
            </em>
          </>
        )}
      </h2>
      {lede && (
        <p
          className="jg-reveal"
          style={{
            marginTop: "1.5rem",
            maxWidth: "52ch",
            fontSize: "1rem",
            lineHeight: 1.6,
            color: "var(--jg-ink-soft)",
          }}
        >
          {lede}
        </p>
      )}
      {steps && (
        <ol className="jg-steps jg-reveal" style={{ marginTop: "2.5rem" }}>
          {steps.map((s) => (
            <li key={s.title}>
              <div>
                <h3>{s.title}</h3>
                <p>{s.description}</p>
                {s.time && <span className="meta">{s.time}</span>}
              </div>
            </li>
          ))}
        </ol>
      )}
      <div className="jg-cta-row jg-reveal">
        {/^https?:\/\//.test(primaryTo) ? (
          <a href={primaryTo} className="jg-btn jg-btn--solid">
            {primaryLabel} <span aria-hidden="true">→</span>
          </a>
        ) : (
          <Link to={primaryTo} className="jg-btn jg-btn--solid">
            {primaryLabel} <span aria-hidden="true">→</span>
          </Link>
        )}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="jg-btn jg-btn--ghost"
        >
          WhatsApp us
        </a>
      </div>
    </div>
  </section>
  </>
);

export default JgCta;
